import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.home-time-zone';
import * as api from '../../../clients/api';

@Injectable()
export class ApiHomeTimeZoneEffects {

    HomeTimeZone$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_HOME_TIME_ZONE),
        mergeMap((x: ac.GetHomeTimeZoneAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getHomeTimeZone().pipe(
                map((result: any) => {
                    return new ac.GetHomeTimeZoneErfolgreichAction(optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetHomeTimeZoneFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ApiService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ApiService {
        if (this.service === null) {
            this.service = this.injector.get(api.ApiService);
        }
        return this.service;
    }
}
